import React from "react";
import Joi from "joi-browser";
import Form from "../common/form";
import { getComapany, updateCompany } from "../../services/companyService";
import { toast } from "react-toastify";
import BlockUi from "react-block-ui";
import TableTitle from "../common/tableTitle";
import { Table } from "semantic-ui-react";
import Currency from "../common/currency";
import { Link } from "react-router-dom";
import auth from "../../services/authService";

class CompanyEditForm extends Form {
  state = {
    data: {
      name: "",
      address: "",
      phone: "",
      p_o_box: "",
      linked_to: "",
    },
    linked_to_options: [
      { id: 0, name: "Select option" },
      { id: 1, name: "JV" },
      { id: 2, name: "SCRAP" },
    ],
    errors: {},
  };

  schema = {
    name: Joi.string().required().label("Company name"),
    address: Joi.string().required().label("Address"),
    phone: Joi.string().required().label("phone"),
    p_o_box: Joi.string().label("P O Box"),
    email: Joi.string().label("Email").allow(""),
    password: Joi.string().label("Password").allow(""),
    linked_to: Joi.number().allow("").label("Linked to"),
  };

  async populateCompany() {
    try {
      const companyId = this.props.match.params.id;
      this.setState({ blocking: true });
      const { data: company } = await getComapany(companyId);
      this.setState({ blocking: false });
      this.setState({ data: this.mapToViewModel(company) });
    } catch (ex) {
      if (ex.response && ex.response.status === 404)
        this.props.history.replace("/not-found");
    }
  }

  async componentDidMount() {
    await this.populateCompany();
  }

  mapToViewModel(company) {
    return {
      name: company.name,
      address: company.address,
      phone: company.phone,
      p_o_box: company.p_o_box,
      email: "",
      password: "",
      linked_to: company.linked_to,
    };
  }

  doSubmit = async () => {
    try {
      const companyId = this.props.match.params.id;

      const data = { ...this.state.data };
      data.id = parseInt(companyId);
      this.setState({ blocking: true });

      await updateCompany(data);
      this.setState({ blocking: false });
      toast.success("Company has been updated successfully.");
      this.props.history.push("/companies");
    } catch (ex) {
      console.log(ex.response);
      if (ex.response && ex.response.status === 422) {
        const errors = { ...this.state.errors };

        if (ex.response.data.errors.name)
          errors.name = ex.response.data.errors.name;

        if (ex.response.data.errors.address)
          errors.address = ex.response.data.errors.address;

        if (ex.response.data.errors.phone)
          errors.phone = ex.response.data.errors.phone;

        if (ex.response.data.errors.p_o_box)
          errors.p_o_box = ex.response.data.errors.p_o_box;

        this.setState({ errors, blocking: false });
        // toast.warning("check validation errors.");
      }
    }
  };

  render() {
    // if (auth.getCurrentUser().email != "client-unblocker@gondalgroup.ae") {
    //   return "Your are authorized to perform this action.";
    // }
    return (
      <BlockUi tag="div" blocking={this.state.blocking}>
        <h1 className="container__heading">Update company</h1>
        <button
          className="btn btn--secondary"
          onClick={() => this.props.history.push("/companies")}
        >
          Back
        </button>
        <form onSubmit={this.handleSubmit}>
          <div className="card form">
            <div className="form__content">
              <h3 className="card__heading">Update company</h3>
              <p>Provide the information below to update the company.</p>
              {this.renderInput("name", "Name", "text")}
              {this.renderInput("address", "Address", "text")}
              {this.renderInput("phone", "Phone", "text")}
              {this.renderInput("p_o_box", "P O Box", "text")}
              {this.renderInput("fullname", "User name", "text")}
              {this.renderInput("email", "Email", "text")}
              {this.renderInput("password", "Password", "password")}
              {this.renderSelect(
                "linked_to",
                "Linked to",
                this.state.linked_to_options
              )}

              {this.renderButton("Update")}
            </div>
          </div>
        </form>
      </BlockUi>
    );
  }
}

export default CompanyEditForm;
